import React, { useCallback, useEffect, useMemo } from "react";
import useMenu from "../../hooks/useMenuContext";
import useAuth from "../../hooks/useAuthContext";
import "./menu.css";
import iconeMenu from "../../assets/header/icone_menu.png";
import ItemMenu from "./itemMenu";
import ItemMenuModal from "./itemMenuModal";

import { IoMdLogOut } from "react-icons/io";
import { FaCogs, FaPaperclip, FaUsers, FaFileSignature } from "react-icons/fa";
import { BiHome, BiUserCircle } from "react-icons/bi";
import {
  BsBell,
  BsStar,
  BsFillChatLeftDotsFill,
  BsMap,
  BsCalendar3,
  BsPin,
  BsFillBriefcaseFill,
} from "react-icons/bs";

const ROLES_ADM = ["administracao", "administracao_dash"];
const ROLES_COM_PORTAL = ["administracao", "administracao_dash", "patrocinador"];

const normalizarTipoMenu = (tipo) =>
  tipo === "participante_patrocinador" ? "patrocinador" : tipo;

const buildItensMenu = (usuario) => {
  const tipo = normalizarTipoMenu(usuario?.tipo);
  const idPatrocinador = usuario?.id_patrocinador;
  const userId = usuario?.id;

  return [
    {
      id: "home",
      label: "Home",
      link: "/private/",
      Icon: BiHome,
      visible: true,
    },
    {
      id: "perfil",
      label: "Perfil",
      link:
        tipo === "patrocinador"
          ? `/private/patrocinador/${idPatrocinador}`
          : "/private/perfil",
      Icon: BiUserCircle,
      visible: true,
    },
    {
      id: "agenda",
      label: "Minha Agenda",
      link: "/private/agenda",
      Icon: BsCalendar3,
      visible: true,
    },
    {
      id: "mapa",
      label: "Mapa",
      link: "/private/mapa",
      Icon: BsMap,
      visible: true,
    },
    {
      id: "reunioes",
      label: "Reuniões",
      link: "/private/reuniao",
      Icon: BsFillBriefcaseFill,
      visible: tipo === "patrocinador",
    },
    {
      id: "avaliacoes",
      label: "Avaliação conteudos",
      link: "/private/avaliacoes",
      Icon: FaFileSignature,
      visible: tipo === "patrocinador" && userId === 46,
    },
    {
      id: "portal-patrocinadores",
      label: "Portal Patrocinadores",
      link: "/portal-patrocinador",
      Icon: FaPaperclip,
      visible: ROLES_COM_PORTAL.includes(tipo),
    },
    {
      id: "mensagens",
      label: "Mensagens",
      link: "/private/chat",
      Icon: BsFillChatLeftDotsFill,
      visible: true,
    },
    {
      id: "patrocinadores",
      label: "Patrocinadores",
      link: "/private/patrocinadores",
      Icon: BsStar,
      visible: true,
    },
    {
      id: "alertas",
      label: "Alertas",
      link: "/private/notificacoes",
      Icon: BsBell,
      visible: true,
    },
    {
      id: "participantes",
      label: "Participantes",
      link: "/private/participantes",
      Icon: FaUsers,
      visible: true,
    },
    {
      id: "pin",
      label: "Pin",
      Icon: BsPin,
      type: "modal",
      visible: tipo !== "patrocinador",
    },
    {
      id: "configuracoes",
      label: "Configurações",
      link: "/private/adm",
      Icon: FaCogs,
      visible: ROLES_ADM.includes(tipo),
    },
  ].filter((item) => item.visible);
};

const Menu = () => {
  const { menuIsOpen, toggleMenu, closeMenu } = useMenu();
  const { logout, usuario } = useAuth();

  const itensVisiveis = useMemo(() => buildItensMenu(usuario), [usuario]);

  const handleLogout = useCallback(() => {
    closeMenu();
    logout();
  }, [closeMenu, logout]);

  useEffect(() => {
    if (!menuIsOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") closeMenu();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [menuIsOpen, closeMenu]);

  return (
    <div
      id="container-menu"
      className={`container-menu ${menuIsOpen ? "mostrar-menu" : "esconder-menu"}`}
      aria-hidden={!menuIsOpen}
      inert={!menuIsOpen}
    >
      <div className="menu-panel">
        <div id="menu-title" className="menu-title">
          <button
            type="button"
            className="menu-botao"
            id="menu-botao"
            onClick={toggleMenu}
            aria-label="Fechar menu"
            aria-expanded={menuIsOpen}
          >
            <img src={iconeMenu} alt="" />
          </button>
          <h2 className="titulo-menu">Menu</h2>
          <button
            type="button"
            id="btn-logout"
            className="btn-logout"
            onClick={handleLogout}
            title="Logout"
            aria-label="Logout"
          >
            <IoMdLogOut />
          </button>
        </div>

        <div id="menu-body" className="menu-body">
          {itensVisiveis.map((item) =>
            item.type === "modal" ? (
              <ItemMenuModal
                key={item.id}
                Icon={item.Icon}
                label={item.label}
              />
            ) : (
              <ItemMenu
                key={item.id}
                Icon={item.Icon}
                label={item.label}
                link={item.link}
                onNavigate={closeMenu}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Menu;
